import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import TextArea from 'client/components/TextArea';

import ListingActions from 'client/actions/Listing';

const SrAskQuestionModal = ({ listingId, userEmail, onClose, dispatch }) => {
  const [step, setStep] = useState(0);
  const [question, setQuestion] = useState('');

  const onClickSendMessage = useCallback(() => {
    setStep(1);
    dispatch(ListingActions.sendQuestionEmail, {
      listingId,
      question,
    });
  }, [dispatch, listingId, question]);

  const step0 = useMemo(
    () => (
      <div className="container">
        <div className="heroIcon">
          <img src="/images/house-illustration2x.png" alt="" />
        </div>
        <div className="modalHeadline">
          <span>Ask a question to the property manager</span>
        </div>
        <div className="margin" />
        <div>
          <TextArea
            className="font-small"
            placeholder="Write your message here..."
            onChange={(e) => setQuestion(e.target.value)}
            value={question}
          />
        </div>
        <div className="margin" />
        <ButtonDeprecated
          type="button"
          theme={BUTTON_THEME_BLUE}
          disabled={!question}
          onClick={onClickSendMessage}
        >
          send message
        </ButtonDeprecated>
      </div>
    ),
    [onClickSendMessage, question],
  );

  const step1 = useMemo(
    () => (
      <div className="container">
        <br />
        <div className="heroIcon">
          <img src="/images/mail-send-green.svg" alt="" />
        </div>
        <div className="modalHeadline">
          <span>Message sent to Cascade Apartments!</span>
        </div>
        <div className="modalMessage">
          <span> Check your email, </span>
          <span className="bold"> {userEmail} </span>
          <span> for a response from the property manager. </span>
        </div>
        <div className="modalFooter">
          <ButtonDeprecated type="button" onClick={onClose}>
            ok thanks!
          </ButtonDeprecated>
        </div>
      </div>
    ),
    [userEmail, onClose],
  );

  return (
    <SrDarkModal className="SrSimpleMessageModal askQuestion">
      <SrModalContent onCloseIconClick={onClose}>
        {step === 0 && step0}
        {step === 1 && step1}
      </SrModalContent>
    </SrDarkModal>
  );
};

SrAskQuestionModal.propTypes = {
  listingId: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

SrAskQuestionModal.displayName = 'SrAskQuestionModal';

export default SrAskQuestionModal;
